import styled from '@xstyled/styled-components';

export const Bar = styled.divBox({
  height: 4,
  borderRadius: 2
});
export const Container = styled.div`
  position: fixed;
  z-index: hud;
  top: 0;
  left: 0;
  right: 0;
  height: 30px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.32) 0%,
    rgba(0, 0, 0, 0.317233) 6.67%,
    rgba(0, 0, 0, 0.308637) 13.33%,
    rgba(0, 0, 0, 0.293869) 20%,
    rgba(0, 0, 0, 0.272828) 26.67%,
    rgba(0, 0, 0, 0.245832) 33.33%,
    rgba(0, 0, 0, 0.213797) 40%,
    rgba(0, 0, 0, 0.178339) 46.67%,
    rgba(0, 0, 0, 0.141661) 53.33%,
    rgba(0, 0, 0, 0.106203) 60%,
    rgba(0, 0, 0, 0.0741679) 66.67%,
    rgba(0, 0, 0, 0.0471716) 73.33%,
    rgba(0, 0, 0, 0.0261312) 80%,
    rgba(0, 0, 0, 0.0113632) 86.67%,
    rgba(0, 0, 0, 0.0027671) 93.33%,
    rgba(0, 0, 0, 0) 100%
  );
  display: flex;
  padding: sm;

  > ${Bar} + ${Bar} {
    margin-left: xs;
  }
`;
